import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Breadcrumbs } from '../components/layout/Breadcrumbs';
import { Card } from '../components/ui/Card';
import { SourceTable } from '../components/reporting/SourceTable';
import { SpeedToLeadChart } from '../components/reporting/SpeedToLeadChart';
import { officers } from '../data/reporting';
import { leadSources } from '../data/configuration';
import { formatSeconds } from '../utils/format';
import { contactRateHealth, healthText, pastDueHealth, speedHealth } from '../utils/health';
export function OfficerDetail() {
  const {
    officerId
  } = useParams();
  const navigate = useNavigate();
  const officer = officers.find(o => o.id === officerId);
  if (!officer) {
    return <Card className="px-6 py-16 text-center text-sm text-ink-500" data-id="element-466" data-mp="2ii2378n1ljc8">Loan Officer not found.</Card>;
  }
  const stats = [{
    label: 'Past Due',
    value: `${officer.pastDuePct}%`,
    tone: healthText[pastDueHealth(officer.pastDuePct)]
  }, {
    label: 'Speed to Lead',
    value: formatSeconds(officer.speedToLeadSeconds),
    tone: healthText[speedHealth(officer.speedToLeadSeconds)]
  }, {
    label: 'Contact Rate',
    value: `${officer.contactRate}%`,
    tone: healthText[contactRateHealth(officer.contactRate)]
  }, {
    label: 'Leads Assigned',
    value: String(officer.leadsAssigned),
    tone: 'text-ink-900'
  }, {
    label: 'Worked Today',
    value: String(officer.leadsWorkedToday),
    tone: 'text-ink-900'
  }, {
    label: 'Remaining',
    value: String(officer.leadsRemaining),
    tone: 'text-ink-900'
  }];
  return <div className="space-y-5" data-id="element-467" data-mp="2riz0imj0ioyi">
      <Breadcrumbs items={[{
      label: 'Management Dashboard',
      to: '/reporting'
    }, {
      label: officer.name
    }]} data-id="element-468" data-mp="2rk0a0mkdr3e4" />

      <div className="flex items-center gap-4" data-id="element-469" data-mp="2mit3eqtz4a91">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink-900 text-sm font-semibold text-white" data-id="element-470" data-mp="2ii0tdvda21bp">
          {officer.initials}
        </span>
        <div data-id="element-471" data-mp="23wlizt7whlzt">
          <h1 className="text-lg font-semibold tracking-tight text-ink-900" data-id="element-472" data-mp="23w3q96kg5pwn">{officer.name}</h1>
          <p className="mt-0.5 text-sm text-ink-500" data-id="element-473" data-mp="27ygmn4db0bgr">Loan Officer · Pacific Team</p>
        </div>
      </div>

      <Card className="grid grid-cols-2 gap-y-5 px-6 py-5 sm:grid-cols-3 lg:grid-cols-6" data-id="element-474" data-mp="1tyyz0sbqv48z">
        {stats.map(stat => <div key={stat.label} data-id="element-475" data-mp="1yxsg0uq8pddw">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-400" data-id="element-476" data-mp="1yz3hgnw7q91u">
              {stat.label}
            </p>
            <p className={`tabular mt-1.5 text-xl font-semibold ${stat.tone}`} data-id="element-477" data-mp="2rm7heegg7x6r">{stat.value}</p>
          </div>)}
      </Card>

      <SourceTable title="Performance by Lead Source" description="Select a source to open the underlying lead list" rows={officer.bySource} onSelect={sourceId => navigate(`/reporting/officer/${officer.id}/source/${sourceId}`)} data-id="element-478" data-mp="2cwicc858j917" />

      <SpeedToLeadChart title="Speed to Lead by Source" description={`${officer.name}'s response time, fastest first`} rows={officer.bySource.map(s => ({
      id: s.sourceId,
      label: leadSources.find(ls => ls.id === s.sourceId)?.name ?? s.sourceId,
      seconds: s.speedToLeadSeconds
    }))} data-id="element-479" data-mp="3acpbamd0oytp" />
    </div>;
}